export const UPDATE_PROFILE_DESCRIPTION = {
    YOUR_EMAIL_USED_TO: 'Your email address is used to:',
    LOGIN_TO_GREENSIGN: 'Log into GreenSign',
    RECEIVE_ENVELOPE_WITH_ENCLOSED_DOCUMENT: 'Receive envelopes with enclosed documents',
    ENVELOPES_SENT_AND_RECEIVED_PREVIOUSLY: 'Envelopes you have sent and received previously:',
    APPEAR_IN_ENVELOPE_LIST: 'Will still appear in your envelope list',
    NOTIFICATION_ABOUT_ENVELOPE: 'Notifications about these envelopes will be sent to the new email address',
    SOMEONE_SENDS_NEW_ENVELOPE_TO_OLD_EMAIL: 'If someone sends you a new envelope to the old email address:',
    NOTIFICATION_TO_OLD_EMAIL: 'GreenSign will send a notification to the old email address',
    NOT_APPEAR_IN_ENVELOPE_LIST: 'It will not appear in the envelopes list of this account',
    MESSAGE_FOR_USER_GUIDE: 'Enter the new email you want to register with GreenSign. This email will require verification.',
    VERIFY_EMAIL_MSG: 'Enter the verification code sent to the following email.',
    DIDNOT_RECEIVE_CODE: "Didn't receive the code?",
    USE_DIFFERENT_EMAIL: 'Use a Different Email',
    MESSAGE_FOR_SSO_USER_GUIDE: 'A verification code has been sent to your email. Please check your inbox and enter the code below to proceed.',
}
export const CODE_REQUIRED = 'Please enter code.'
export const EMAIL_UPDATED_SUCCESSFULLY = 'Email updated Successfully'
export const CHANGE_EMAIL_WARNING_MSG = 'Changing the email address associated with GreenSign should be done carefully'
